import React from 'react';
import { ArrowRight } from 'lucide-react';
import { trackPixelEvent } from './MetaPixel';
interface CTAButtonProps {
  text?: string;
  microtext?: string;
  href?: string;
  className?: string;
}
export function CTAButton({
  text = 'QUIERO RECUPERAR MI VALOR',
  microtext = '↓ HAZ CLIC AQUÍ ABAJO ↓',
  href = 'https://colorpack.store/cart/45914855866566:1',
  className = ''
}: CTAButtonProps) {
  const handleClick = () => {
    trackPixelEvent('InitiateCheckout', {
      content_name: 'Ebook MERECES MÁS',
      value: 10.99,
      currency: 'USD'
    });
  };
  return <div className={`flex flex-col items-center justify-center w-full my-8 ${className}`} data-id="element-38">
      {microtext && <span className="text-brand-wine font-bold text-sm mb-2 uppercase tracking-wider" data-id="element-39">
          {microtext}
        </span>}
      <a href={href} onClick={handleClick} className="group relative flex items-center justify-center w-full max-w-xl bg-brand-yellow hover:bg-brand-yellowHover text-brand-wineDark font-black text-xl md:text-2xl py-5 px-6 rounded-lg shadow-[0_8px_20px_rgba(255,217,61,0.4)] hover:shadow-[0_12px_25px_rgba(255,217,61,0.6)] transition-all duration-300 animate-buttonPulse border-b-4 border-[#D4B020] hover:border-[#B39315]" data-id="element-40">
        <span className="text-center flex items-center gap-3" data-id="element-41">
          {text}
          <ArrowRight className="w-6 h-6 md:w-8 md:h-8 group-hover:translate-x-1 transition-transform" strokeWidth={3} data-id="element-42" />
        </span>
      </a>
      <p className="text-xs text-gray-500 mt-3 flex items-center gap-1 font-medium" data-id="element-43">
        <span className="text-green-600" data-id="element-44">🔒</span> Pago 100% seguro · Acceso
        inmediato
      </p>
    </div>;
}